<template>
  <side-bar>
    <template #links>
      <sidebar-item
        v-for="(item, index) of listItems"
        v-if="!!item.children ? true : $can(item.permission)"
        :key="'sidebar_item_' + index"
        :link="item"
      >
        <template v-if="item.children">
          <sidebar-item
            v-for="(child, childIndex) of item.children"
            v-if="$can(child.permission)"
            :key="'child_index_' + childIndex"
            :link="child"
          />
        </template>
      </sidebar-item>
    </template>

    <template #links-after>
      <hr class="my-3" />
      <h6 class="navbar-heading p-0 text-muted">Outros Cadastros</h6>

      <ul class="navbar-nav mb-md-3">
        <li
          class="nav-item"
          v-for="(item, index) of outrosCadastros"
          v-if="$can(item.permission)"
          :key="'nav_item_' + index"
        >
          <router-link :to="item.to" class="nav-link">
            <font-awesome-icon :icon="item.icon" class="mr-2" />
            <span class="nav-link-text">{{ item.label }}</span>
          </router-link>
        </li>
      </ul>

      <hr class="my-3" />
      <h6 class="navbar-heading p-0 text-muted">Configurações</h6>

      <ul class="navbar-nav mb-md-3">
        <li
          class="nav-item"
          v-for="(item, index) of configuracoes"
          v-if="$can(item.permission)"
          :key="'nav_item_' + index"
        >
          <router-link :to="item.to" class="nav-link">
            <font-awesome-icon :icon="item.icon" class="mr-2" />
            <span class="nav-link-text">{{ item.label }}</span>
          </router-link>
        </li>
      </ul>


    </template>
  </side-bar>
</template>

<script>
export default {
  data() {
    return {
      listItems: [
        {
          name: "Página Inicial",
          icon: "home",
          path: "/",
        },
        {
          name: "Conselhos",
          icon: "users",
          iconClass: "text-orange",
          children: [
            {
              name: "Gestão",
              path: { name: "conselhos_list" },
              permission: "conselhos:view",
            },
            {
              name: "Secretaria Executiva",
              path: { name: "secretarias_executivas_list" },
              permission: "sec-executiva:view",
            },
            {
              name: "Plenárias",
              path: { name: "plenarias_list" },
              permission: "plenarias:view",
            },
            {
              name: "Conselheiros",
              path: { name: "conselheiros_list" },
              permission: "conselheiros:view",
            },
            {
              name: "Biblioteca do Conselho",
              path: { name: "bibliotecas_list" },
              permission: "conselhos:view",
            },
          ],
        },
        {
          name: "Mesa Diretora",
          icon: "user-graduate",
          iconClass: "text-success",
          path: { name: "mesas_diretoras_list" },
          permission: "mesa-diretora:view",
        },
        {
          name: "Comissões",
          icon: "lightbulb",
          iconClass: "text-yellow",
          path: { name: "comissoes_list" },
          permission: "comissoes:view",
        },
      ],
      outrosCadastros: [
        {
          to: { name: "pessoas_fisica_list" },
          icon: "angle-right",
          label: "Pessoas Físicas",
          permission: "pessoas-fisicas:view",
        },
        {
          to: { name: "pessoas_juridica_list" },
          icon: "angle-right",
          label: "Pessoas Jurídicas",
          permission: "pessoas-juridicas:view",
        },
        {
          to: { name: "entidades_list" },
          icon: "angle-right",
          label: "Representações",
          permission: "grupo-entidades:view",
        },
        {
          to: { name: "files_list" },
          icon: "angle-right",
          label: "Biblioteca de Arquivos",
          permission: "files:view",
        },
      ],
      configuracoes: [
        {
          to: { name: "users_list" },
          icon: "angle-right",
          label: "Usuários",
          permission: "users:view",
        },
        {
          to: { name: "acl_list" },
          icon: "angle-right",
          label: "Papeis e Permissões",
          permission: "roles:view",
        },
        {
          to: "#!",
          icon: "angle-right",
          label: "Configuração",
          permission: [],
        },
      ],
    };
  },
  computed: {},
  methods: {
    hasOnePermission(permissions = []) {
      let valid = permissions.length ? false : true;

      permissions.forEach((permission) => {
        valid = valid || this.$can(permission);
      });

      return valid;
    },
  },
};
</script>
